"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledDropdownMulti = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const styled_1 = require("./styled");
exports.StyledDropdownMulti = (0, styled_components_1.default)(styled_1.StyledDropdown) `
  [data-testid="input-container"] {
    display: flex;
    flex-wrap: wrap;
    [data-testid="icon-value"] {
      position: relative;
      transform: none;
      left: 0;
      margin: 0 0.25rem 0.25rem 0;
      flex: none;
    }
    [data-testid="input"] {
      visibility: visible;
      flex: none;
      padding-left: 0;
    }
    [data-testid="input-icon-right"] {
      flex: none;
    }
  }
`;
//# sourceMappingURL=multiple.styled.js.map